import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './Button';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Neuropathy',
    href: '#neuropathy'
  }, {
    name: 'Treatments',
    href: '#treatments'
  }, {
    name: 'Results',
    href: '#results'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-131">
      <div className="container mx-auto px-4 h-20 flex items-center justify-between" data-id="element-132">
        <a href="#" className="flex items-center" aria-label="The Neuropathy & Healing Center — home" data-id="element-133">
          <img src="https://cdn.magicpatterns.com/uploads/be5SqDSFguqgTJHkx6oq5s/mobile_the_neuropathy_healing_center_logo_1200px.png" alt="The Neuropathy & Healing Center" className="h-12 w-auto" data-id="element-134" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-135">
          <ul className="flex items-center gap-6" data-id="element-136">
            {navLinks.map(link => <li key={link.name} data-id="element-137">
                <a href={link.href} className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors" data-id="element-138">
                  {link.name}
                </a>
              </li>)}
          </ul>
          <div className="flex items-center gap-4" data-id="element-139">
            <a href="tel:9041234567" className="flex items-center gap-2 text-sm font-medium hover:text-primary transition-colors" data-id="element-140">
              <Phone className="w-4 h-4" data-id="element-141" />
              (904) 123-4567
            </a>
            <Button asChild data-id="element-142">
              <a href="#contact" data-id="element-143">Free Consultation</a>
            </Button>
          </div>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden p-2" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Menu" data-id="element-144">
          {isOpen ? <X className="w-6 h-6" data-id="element-145" /> : <Menu className="w-6 h-6" data-id="element-146" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && <motion.div initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden border-t bg-background absolute w-full" data-id="element-147">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-4" data-id="element-148">
            <ul className="flex flex-col gap-4" data-id="element-149">
              {navLinks.map(link => <li key={link.name} data-id="element-150">
                  <a href={link.href} className="block text-base font-medium text-foreground" onClick={() => setIsOpen(false)} data-id="element-151">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <div className="flex flex-col gap-4 pt-4 border-t" data-id="element-152">
              <a href="tel:9041234567" className="flex items-center gap-2 text-base font-medium" data-id="element-153">
                <Phone className="w-5 h-5 text-primary" data-id="element-154" />
                (904) 123-4567
              </a>
              <Button className="w-full" asChild onClick={() => setIsOpen(false)} data-id="element-155">
                <a href="#contact" data-id="element-156">Schedule Free Consultation</a>
              </Button>
            </div>
          </div>
        </motion.div>}
    </header>;
}